// Mã VietQR cho dòng chuyển khoản: số tài khoản, số tiền, nội dung = mã đơn
import { useEffect, useState } from 'react';
import { Loader2, QrCode } from 'lucide-react';
import usePosStore from '../store';
import { money } from '../utils';

export default function VietQR({ amount, content, className = 'mt-3' }: { amount: number; content: string; className?: string }) {
  const bank = usePosStore(s => s.config.bank);
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const info = content.replace(/[^A-Za-z0-9]/g, '');
  const src = `https://img.vietqr.io/image/${bank.bankId}-${bank.accountNo}-compact.png?amount=${amount}&addInfo=${encodeURIComponent(info)}&accountName=${encodeURIComponent(bank.accountName)}`;
  // Đổi số tiền → ảnh mới, hiện lại trạng thái đang tải thay vì ô trắng
  useEffect(() => { setLoaded(false); setFailed(false); }, [src]);
  return (
    <div className={`flex items-center gap-4 rounded-lg border border-dashed border-slate-300 bg-white p-3 ${className}`}>
      {failed || amount <= 0 ? (
        <div className="flex h-28 w-28 shrink-0 items-center justify-center rounded-lg bg-slate-100"><QrCode className="h-10 w-10 text-slate-400" /></div>
      ) : (
        <div className="relative h-28 w-28 shrink-0">
          {!loaded && (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-1 rounded-lg bg-slate-100 text-xs text-slate-500">
              <Loader2 className="h-5 w-5 animate-spin" /> Đang tạo mã…
            </div>
          )}
          <img key={src} src={src} alt="Mã VietQR" onLoad={() => setLoaded(true)} onError={() => setFailed(true)}
            className={`h-28 w-28 rounded-lg object-contain ${loaded ? '' : 'invisible'}`} />
        </div>
      )}
      <div className="min-w-0 text-sm text-slate-600">
        <p className="font-semibold text-slate-800">Khách quét mã VietQR để chuyển khoản</p>
        <p>Ngân hàng: <b>{bank.bankId}</b> · STK <b>{bank.accountNo}</b></p>
        <p>Chủ TK: {bank.accountName}</p>
        <p>Số tiền: <b>{money(amount)}đ</b> · Nội dung: <b className="font-mono">{info}</b></p>
        {failed && <p className="text-xs text-amber-600">Không tải được ảnh QR – đọc thông tin chuyển khoản cho khách.</p>}
      </div>
    </div>
  );
}
